import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'core-js/modules/es.string.replace-all';
import './polyfills/string_prototype_replaceall';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


reportWebVitals();
